// Polyfills
import 'Utils/_closest.polyfill.js';
import 'Utils/_matches.polyfill.js';

// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Components
//import { disablePageScroll, enablePageScroll, addFillGapTarget, addFillGapSelector, setFillGapMethod } from 'scroll-lock';
import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';


document.addEventListener('DOMContentLoaded', function() {
	//let mm = gsap.matchMedia();
	var r = document.querySelector(':root');
	var body = document.body;

	// HELP CHECK
	/*
	let viewportWidthEl = document.getElementById('viewport-width');

	function viewportCalc() {
		//let viewportHeight = window.innerHeight;
		let viewportWidth = window.innerWidth;
		//console.log(viewportWidth);
		//console.log(viewportHeight);

		if(window.innerWidth < 576){
			viewportWidthEl.style.backgroundColor = "red";
            viewportWidthEl.innerText = 'xs';
			//viewportHeightEl.style.backgroundColor = "red";

		} else if(window.innerWidth < 768) {
			viewportWidthEl.style.backgroundColor = "orange";
            viewportWidthEl.innerText = 'sm';

			//viewportHeightEl.style.backgroundColor = "purple";

		} else if(window.innerWidth < 992) {
			viewportWidthEl.style.backgroundColor = "green";
            viewportWidthEl.innerText = 'md';
			//viewportHeightEl.style.backgroundColor = "blue";

		} else if(window.innerWidth < 1200) {
			viewportWidthEl.style.backgroundColor = "blue";
            viewportWidthEl.innerText = 'lg';
			//viewportHeightEl.style.backgroundColor = "green";

		} else if(window.innerWidth < 1400) {
			viewportWidthEl.style.backgroundColor = "purple";
            viewportWidthEl.innerText = 'xl';
			//viewportHeightEl.style.backgroundColor = "orange";
		}

		else {
			viewportWidthEl.style.backgroundColor = "black";
            viewportWidthEl.innerText = 'xxl';
			//viewportHeightEl.style.backgroundColor = "black";
		}
	}

	viewportCalc();

	// RESIZE
	window.addEventListener("resize", function(){
		viewportCalc();
	});
	*/

	// HEADER TINY ON SCROLL
	/*
	mm.add("(min-width: 992px)", () => {
		ScrollTrigger.create({
			start: "top -100px",
			//scroller: scrollerBox,
			end: 99999,
			//markers: true,

			toggleClass: { targets: 'header', className: '--tiny' },
		});
	});

	mm.add("(max-width: 991px)", () => {
		ScrollTrigger.create({
			start: "top -30px",
			//scroller: scrollerBox,
			end: 99999,
			//markers: true,

			toggleClass: { targets: 'header', className: '--tiny' },
		});
	});
	*/	

	// SWIPERS
	const swiperStructuresNeuves = new Swiper('.--structures-neuves-swiper .swiper-container', {
			modules: [Navigation, Autoplay, Pagination],
			loop: true,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			navigation: {
				nextEl: ".--structures-neuves-swiper .swiper-button-next",
				prevEl: ".--structures-neuves-swiper .swiper-button-prev",
			}, 
			pagination: {
				el: ".--structures-neuves-swiper .swiper-pagination",
			},
			breakpoints: {
				// when window width is >= 320px
				768: {
				slidesPerView: 2,
				spaceBetween: 20
				},
				// when window width is >= 768px
				992: {
					spaceBetween: 40,
					slidesPerView: 2,
				},
				// when window width is >= 992px
				1200: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				// when window width is >= 2000px
				2000: {
					slidesPerView: 3,
					spaceBetween: 40,
				}
			},
	});

	const swiperEtudeRenovation = new Swiper('.--etude-renovation-swiper .swiper-container', {
			modules: [Navigation, Autoplay, Pagination],
			loop: true,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			navigation: {
				nextEl: ".--etude-renovation-swiper .swiper-button-next",
				prevEl: ".--etude-renovation-swiper .swiper-button-prev",
			}, 
			pagination: {
				el: ".--etude-renovation-swiper .swiper-pagination",
			},			
			breakpoints: {
				// when window width is >= 320px
				768: {
				slidesPerView: 2,
				spaceBetween: 20
				},
				// when window width is >= 768px
				992: {
					spaceBetween: 40,
					slidesPerView: 2,
				},
				// when window width is >= 992px
				1200: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				// when window width is >= 2000px
				2000: {
					slidesPerView: 3,
					spaceBetween: 40,
				}
			},
	});

	const swiperStructuresPhotovoltaique = new Swiper('.--structures-photovoltaique-swiper .swiper-container', {
			modules: [Navigation, Autoplay, Pagination],
			loop: true,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			navigation: {
				nextEl: ".--structures-photovoltaique-swiper .swiper-button-next",
				prevEl: ".--structures-photovoltaique-swiper .swiper-button-prev",
			}, 
			pagination: {
				el: ".--structures-photovoltaique-swiper .swiper-pagination",
			},
			breakpoints: {
				// when window width is >= 320px
				768: {
				slidesPerView: 2,
				spaceBetween: 20
				},
				// when window width is >= 768px
				992: {
					spaceBetween: 40,
					slidesPerView: 2,
				},
				// when window width is >= 992px
				1200: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
				// when window width is >= 2000px
				2000: {
					slidesPerView: 3,
					spaceBetween: 40,
				}
			},
	});

	//// COMP LEFT MARGIN CALC
	var mainCompsLeftImg = document.querySelectorAll('.comp > .container:not(.--reverse');
	var mainCompsRightImg = document.querySelectorAll('.comp > .container.--reverse');

	var swipeIconsLeft = document.querySelectorAll('.icon-swipe.--left');
	var swipeIconsRight = document.querySelectorAll('.icon-swipe.--right');

	function xtremLeftImgCalc() {
		let windowSize = window.innerWidth;
		let offsetAdd;
		if (windowSize < 1600) {
			offsetAdd = 50;
		} else {
			offsetAdd = 75;
		}
		let mql = window.matchMedia('(min-width:1600px) and (max-width: 1920px)');
		//console.log(offsetAdd);
		//console.log(swipeIconsRight.length);

		if(mql.matches == true) {
			mainCompsLeftImg.forEach(mainCompLeftImg => {
				let mainCompsLeftImgNumber = mainCompLeftImg.offsetLeft + offsetAdd;

				mainCompLeftImg.querySelector('.img-container').style.setProperty('width', 'calc(100% + ' + mainCompsLeftImgNumber + 'px)');
				mainCompLeftImg.querySelector('.img-container').style.marginLeft = "-" + mainCompsLeftImgNumber + "px";
			});
		
			mainCompsRightImg.forEach(mainCompRightImg => {
				let mainCompsRightImgNumber = mainCompRightImg.offsetLeft + offsetAdd;

				mainCompRightImg.querySelector('.img-container').style.setProperty('width', 'calc(100% + ' + mainCompsRightImgNumber + 'px)');
				mainCompRightImg.querySelector('.img-container').style.marginRight = "-" + mainCompsRightImgNumber + "px";
			});

			swipeIconsLeft.forEach(swipeIconLeft => {
				let swipeIconLeftNumber = swipeIconLeft.offsetLeft;

				swipeIconLeft.querySelector('svg').style.marginLeft = "-" + swipeIconLeftNumber + "px";
			});

			swipeIconsRight.forEach(swipeIconRight => {
				let swipeIconRightNumber = swipeIconRight.offsetLeft;

				swipeIconRight.querySelector('svg').style.marginRight = "-" + swipeIconRightNumber + "px";
			});
			
		} else {
			mainCompsLeftImg.forEach(mainCompLeftImg => {
				mainCompLeftImg.querySelector('.img-container').style.setProperty('width', '');
				mainCompLeftImg.querySelector('.img-container').style.marginLeft = "";
			});

			mainCompsRightImg.forEach(mainCompRightImg => {
				mainCompRightImg.querySelector('.img-container').style.setProperty('width', '');
				mainCompRightImg.querySelector('.img-container').style.marginRight = "";
			});

			swipeIconsLeft.forEach(swipeIconLeft => {
				swipeIconLeft.querySelector('svg').style.marginLeft = "";
			});

			swipeIconsRight.forEach(swipeIconRight => {
				swipeIconRight.querySelector('svg').style.marginRight = "";
			});
		}
    }

	xtremLeftImgCalc();

	// RESIZE
	addEventListener("resize", (event) => {
		xtremLeftImgCalc();
	});

	//// SECTION APPEAR
	addEventListener("load", (event) => {
	//// Scroll Animation
	var sections = document.querySelectorAll('.section');

	function myFunction(x) {			
		if (x.matches) { // If media query matches
			var options = {
				rootMargin: '0px',
				threshold: 0.1
			}
		
			var callback = (entries) => {
				entries.forEach((entry) => {
					var target = entry.target;
					
					if (entry.intersectionRatio >= 0.1) {
						target.classList.add("is-inview");
					} else {
						//target.classList.remove("is-inview");
					}
				})
			}
		
			var observer = new IntersectionObserver(callback, options)
			
			sections.forEach((section, index) => {
				observer.observe(section)
			})
		} else {
			var options = {
				rootMargin: '0px',
				threshold: 0.6
			}
		
			var callback = (entries) => {
				entries.forEach((entry) => {
					var target = entry.target;
					
					if (entry.intersectionRatio >= 0.5) {
						target.classList.add("is-inview");
						
					} else {
						//target.classList.remove("is-inview");
					}
				})
			}
		
			var observer = new IntersectionObserver(callback, options)
			
			sections.forEach((section, index) => {
				observer.observe(section)
			})
		}
	}
	  
	// Create a MediaQueryList object
	var x = window.matchMedia("(max-height: 1199px)");
	
	// Call listener function at run time
	myFunction(x);
	
	// Attach listener function on state changes
	x.addEventListener("change", function() {
		myFunction(x);
	});
});

})


